export default __webpack_public_path__ + "static/media/Radio_button-checked.97bce245.svg";